import * as THREE from "three";
import React, { useState, useEffect, memo } from "react";
import { SplineSurface, Spline, MakeSplinePoints } from "../shape/Spline";
import { PointsDrag2D } from "../shape/PointDrag2D";
import { PointsClick } from "../shape/PointClick";
import Control from '../store/control';
import { Lines } from "../shape/Line";
import { Points } from "../shape/Point";
import { DIV_LINE, DIV_CLICK } from '../store/global';
import { getMiddlePointsOnSpline } from '../shape/utils';

//-----------------------------------------
// 与えられた2D点群vpoints（＝ドラッグ可能）から、
// それらの中点（＝クリック可能）と、
// それらの点をsplineで結んだ線or平面を描画するマーカである。
// showtypeは点群を結ぶ部分の表示を線(1D)か平面(2D)で指定する。
// 点をクリックすると、ドラッグ可能な点に変わる。
//-----------------------------------------

// showtype: 1D / 2D
// callback: (Out)


const MPoints2DAdd = memo(({ vpoints, colorLine, colorDrag, colorClick, size1, size2, showtype, callback=null, offset=new THREE.Vector3(0,0,0), dirSurface='x', spline=true }) => {
  if(!vpoints) return null;

  const width = 200;

  var [lvpoints, setVpoints]        = useState(vpoints);
  var [clickPoints, setClickPoints] = useState();
  const currentAngle  = Control.Get("currentAngle");

  /**
   * Updates the position of a point in the lvpoints array.
   * 
   * @param {string} uuid - The unique identifier of the point.
   * @param {number[]} position - The new position of the point as an array of three numbers [x, y, z].
   */
  const callEnd = (uuid, position) => {
    // console.log("-----callEnd-----", uuid);
    var newnodes = lvpoints.slice();
    newnodes[uuid] = new THREE.Vector3(position[0], position[1], position[2]);
    setVpoints(newnodes);
  };

  /**
   * Adds a new point to the list of points.
   * @param {number} uuid - The index at which the new point should be inserted.
   */
  const callAdd = (uuid) => {
    //console.log("-----callAdd-----", uuid);
    var newnodes = lvpoints.slice();
    newnodes.splice(uuid+1, 0, clickPoints[uuid]);
    setVpoints(newnodes);
  }

  // set click points, new points are added as control points
  useEffect(() => {
    //const cPoints = getSplineClickPoints(lvpoints)
    const cPoints = getMiddlePointsOnSpline(lvpoints)
    setClickPoints(cPoints);
    if (callback) callback(lvpoints);
  }, [lvpoints]);

  // const vlines = [];
  // for (let i = 0; i < lvpoints.length - 1; i++) {
  //   const pt0 = new THREE.Vector3(lvpoints[i].x-200, lvpoints[i].y, lvpoints[i].z);
  //   const pt1 = new THREE.Vector3(lvpoints[i].x+200, lvpoints[i].y, lvpoints[i].z);
  //   vlines.push([pt0, pt1]);
  // }
  
  const offsetPointsDrag = [];
  lvpoints.forEach(p => {
    offsetPointsDrag.push(new THREE.Vector3(p.x-width, p.y, p.z));
    offsetPointsDrag.push(new THREE.Vector3(p.x+width, p.y, p.z));
  });
  
  if (clickPoints && clickPoints.length > 0) {
    const offsetPointsClick = [];
    clickPoints.forEach(p => {
      offsetPointsClick.push(new THREE.Vector3(p.x-width, p.y, p.z));
      offsetPointsClick.push(new THREE.Vector3(p.x+width, p.y, p.z));
    });
  }

  return (
    <>
      {(showtype == "2D") && (spline)
        ? <SplineSurface vpoints={lvpoints} width={width} color={colorLine} close={false} div={5} dirSurface={dirSurface}/>
        : <Spline vpoints={lvpoints} color={colorLine} lineWidth={2} close={false} />}
      <PointsDrag2D vpoints={lvpoints} color={colorDrag} size={size1} angle={currentAngle} callEnd={callEnd}/>
      <PointsClick vpoints={clickPoints} color={colorClick} size={size2} callback={callAdd}/>
      <Points vpoints={offsetPointsDrag} color={colorDrag} size={size1}/>
    </>
  );
});
export default MPoints2DAdd;

/**
 * Calculates the spline click points based on the given control points.
 * 
 * @param {Array} vpoints - The control points for the spline.
 * @returns {Array} - The calculated spline click points.
 */
const getSplineClickPoints = (vpoints) => {
  const tmp = MakeSplinePoints(vpoints, false, DIV_CLICK);

  //元の点は除く
  var cPoints = [];
  tmp.forEach((p, i) => {
    if(i % DIV_CLICK != 0) cPoints.push(p);
  });

  return cPoints;
}

